import { render } from "./ReferralPharmacy.vue?vue&type=template&id=3c7c1d25&ts=true"
import script from "./ReferralPharmacy.ts?vue&type=script&lang=ts&external"
export * from "./ReferralPharmacy.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__